import { Analytics } from "views/analytics/analytics";
console.log("🔍 Analytics import:", Analytics);
import { Dashboard } from "views/dashboard/dashboard";
import { Help } from "views/dashboard/help";
import { OnboardingView } from "views/onboarding/onboarding";
import { Studio } from "views/studio/studio";
import { Team } from "views/team/team";
import { APIKeyList } from "views/apikey/list";
import { APIKeyEditor } from "views/apikey/edit";
import { Billing } from "views/billing";
import { FreeTierUpgrade } from "views/billing/upgrade";
import { SuperAdminDashboard } from "views/admin/super-dashboard";

const Routes = [
  {
    path: "/",
    view: Dashboard,
    layout: "dashboard",
    permission: "user",
    title: "dashboard.title",
  },
  {
    path: "/dashboard",
    view: Dashboard,
    layout: "dashboard",
    permission: "user",
    title: "dashboard.title",
  },
  {
    path: "/analytics",
    view: Analytics,
    layout: "dashboard",
    permission: "user",
    title: "analytics.title",
  },
  {
    path: "/team",
    view: Team,
    layout: "app",
    permission: "user",
    title: "team.title",
  },
  {
    path: "/studio",
    view: Studio,
    layout: "app",
    permission: "user",
    title: "studio.title",
  },
  {
    path: "/keys",
    view: APIKeyList,
    layout: "account",
    permission: "user",
    title: "api_keys.title",
  },
  {
    path: "/keys/create",
    view: APIKeyEditor,
    layout: "account",
    permission: "user",
    title: "api_keys.title",
  },
  {
    path: "/keys/edit",
    view: APIKeyEditor,
    layout: "account",
    permission: "user",
    title: "api_keys.title",
  },
  {
    path: "/billing",
    view: Billing,
    layout: "account",
    permission: "owner",
    title: "billing.title",
  },
  {
    path: "/billing/upgrade",
    view: FreeTierUpgrade,
    layout: "account",
    permission: "owner",
    title: "billing.title",
  },
  {
    path: "/welcome",
    view: OnboardingView,
    layout: "onboarding",
    permission: "user",
    title: "onboarding.title",
  },
  {
    path: "/help",
    view: Help,
    layout: "app",
    permission: "user",
    title: "help.title",
  },
  {
    path: "/admin/super-dashboard",
    view: SuperAdminDashboard,
    layout: "dashboard",
    permission: "user", // "master",
    title: "Super Admin",
  },
];

console.log("🗺️ App Routes:", Routes);
export default Routes;
